import React, { Component } from 'react';

export class KeyValue extends Component
{
    //[key,value,hidden (optional)]
   constructor(props) {
		super(props);
    }
    render()
	{
		return(            
            <table>
                <tbody>
                {
                    this.props.values.map((row,i)=>{
                        return(
                        <tr key={row.key} style={{display:row.hidden?'none':'table-row'}}>
                            <td style={{whiteSpace: 'nowrap'}} className='font-light'>{row.key}</td>
                            <td style={{width:'20px',textAlign:'center'}}>:</td>
                            <td style={{whiteSpace: 'nowrap'}}>{row.value}</td>
                        </tr>
                        );
                    })
                }
                </tbody>
            </table>
        );
	}
}
export default KeyValue;